<template>
  <path
    d="M6 10.0002C4.9 10.0002 4 10.9002 4 12.0002C4 13.1002 4.9 14.0002 6 14.0002C7.1 14.0002 8 13.1002 8 12.0002C8 10.9002 7.1 10.0002 6 10.0002ZM18 10.0002C16.9 10.0002 16 10.9002 16 12.0002C16 13.1002 16.9 14.0002 18 14.0002C19.1 14.0002 20 13.1002 20 12.0002C20 10.9002 19.1 10.0002 18 10.0002ZM12 10.0002C10.9 10.0002 10 10.9002 10 12.0002C10 13.1002 10.9 14.0002 12 14.0002C13.1 14.0002 14 13.1002 14 12.0002C14 10.9002 13.1 10.0002 12 10.0002Z"
  />
</template>
